import { GamepadLeftIcon } from './GamepadLeftIcon';

/**
 * author: GreenTurtwig
 * id D8A2D400-73A0-467E-9144-581D51735E0F
 * name gamepad-left
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-left.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerLeftIcon = GamepadLeftIcon;
export default ControllerLeftIcon